import { css } from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../../../styles/common/mixins/helpers.styled.js";
const veciPassengersStyles = {
    PassengersWrapper: ()=>css`
		padding: 0;

		.passanger-row {
			${FlexMixin({
            direction: 'column'
        })}
			border-top: 1px solid ${({ theme  })=>theme.border.color.light};

			&:first-of-type {
				border-top: 0;
			}

			.person-counter-horizontal {
				margin-top: 12px;

				.person-counter-select {
					border: 1px solid ${({ theme  })=>theme.border.color.light};
					border-radius: 4px;
					min-width: 110px;
				}

				.person-counter-title {
					${FontMixin({
            weight: 'regular'
        })}
					color: ${({ theme  })=>theme.colors.text.dark};
				}
			}
		}

		.person-counter {
			${FlexMixin({
            direction: 'row',
            align: 'center'
        })}
			gap: 12px;

			label {
				color: ${({ theme  })=>theme.colors.primary.dark};
			}

			.decrement,
			.increment {
				height: 32px;
				width: 32px;
			}
		}

		.input-panel-header {
			border-bottom: 0;
			padding: 12px 16px 4px;
		}

		.passengers-footer {
			button {
				border-radius: 3px;
				min-height: 40px;
				min-width: 92px;
				font-weight: 400;
				background-color: ${({ theme  })=>theme.colors.primary.base};
				&:hover,
				&:active {
					background-color: ${({ theme  })=>theme.colors.primary.lighter};
				}
			}

			&-text {
				${FontMixin({
            size: 'medium',
            weight: 'regular',
            height: 'base'
        })}
				color: ${({ theme  })=>theme.colors.grays.base};
			}
		}

		.input-panel-footer {
			border-top: 0;
		}
	`
};
export default veciPassengersStyles;

//# sourceMappingURL=veci.js.map